import React from "react";
import { useLocation } from "react-router-dom";
import FloatingLanguageSelector from "../../components/FloatingLanguageSelector";

interface NonAuthLayoutProps {
  children: any;
}

const NonAuthLayout = (props: NonAuthLayoutProps) => {
  const location = useLocation();
  const isOnboarding = location.pathname === "/onboarding";

  return (
    <div className="non-auth-layout-wrapper">
      {/* Language selector — hidden on onboarding (it has its own step) */}
      {!isOnboarding && <FloatingLanguageSelector />}
      {props.children}
    </div>
  );
};

export default NonAuthLayout;
